import React, { useState } from 'react';
import Layout from '../components/Layout';

function CreateASCDispatch({ user, onLogout }) {
  const [selectedASC, setSelectedASC] = useState('');
  const [devices, setDevices] = useState([]);
  const [scannedCode, setScannedCode] = useState('');

  const handleScanDevice = (e) => {
    e.preventDefault();
    if (scannedCode) {
      setDevices([...devices, { code: scannedCode, sku: 'Unknown' }]);
      setScannedCode('');
    }
  };

  const handleCreateDispatch = () => {
    alert('ASC Dispatch creation will be implemented');
  };

  return (
    <Layout user={user} onLogout={onLogout}>
      <div className="p-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Create ASC Dispatch</h1>
          <p className="text-gray-600 mt-2">Send devices to ASC partner for repair</p>
        </div>

        {/* ASC Selection */}
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">Select ASC Partner</label>
          <select
            value={selectedASC}
            onChange={(e) => setSelectedASC(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">-- Select ASC Partner --</option>
            <option value="asc1">ASC Partner 1</option>
            <option value="asc2">ASC Partner 2</option>
          </select>
        </div>

        {/* Device Scanning */}
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">Scan Devices</h2>
          <form onSubmit={handleScanDevice} className="flex gap-2">
            <input
              type="text"
              value={scannedCode}
              onChange={(e) => setScannedCode(e.target.value)}
              placeholder="Scan or enter device code"
              className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
            >
              Add
            </button>
          </form>
        </div>

        {/* Devices List */}
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">Devices to Dispatch ({devices.length})</h2>
          {devices.length === 0 ? (
            <p className="text-gray-600">No devices added yet</p>
          ) : (
            <div className="space-y-2">
              {devices.map((device, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded">
                  <div>
                    <p className="font-medium">{device.code}</p>
                    <p className="text-sm text-gray-600">{device.sku}</p>
                  </div>
                  <button
                    onClick={() => setDevices(devices.filter((_, i) => i !== index))}
                    className="text-red-600 hover:text-red-800"
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Create Button */}
        {devices.length > 0 && selectedASC && (
          <button
            onClick={handleCreateDispatch}
            className="w-full px-4 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 font-semibold"
          >
            Create Dispatch
          </button>
        )}
      </div>
    </Layout>
  );
}

export default CreateASCDispatch;
